module.exports = __webpack_public_path__ + "img/health.ebd709f4.png";